import React from 'react';

import { isMutation, isSubscription } from 'src/lib/metrics';

import { MutationBadge } from './MutationBadge';
import { SubscriptionBadge } from './SubscriptionBadge';

export const OperationTypeBadge = ({
  signature,
  disableTooltip,
  size,
}: {
  signature?: string | null;
  disableTooltip?: boolean;
  size?: 'normal' | 'lg';
}) => {
  // TODO: we can remove this check for signature if the BE returns the operation type
  // in the OperationsPageQuery. Then we can just use the type, remove use of the isMutation and isSubscription
  // and check for the enums instead. This component could then be used in both OperationsMainContent and OperationListItem
  if (signature !== null && signature !== undefined) {
    return isMutation(signature) ? (
      <MutationBadge disableTooltip={disableTooltip} size={size} />
    ) : isSubscription(signature) ? (
      <SubscriptionBadge disableTooltip={disableTooltip} size={size} />
    ) : null;
  }
  return null;
};
